import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router";
import Admin from "./Admin";
import Home from "./Home";
import PostsPage from "./site/PostsPage";

export default function App() {
  return <BrowserRouter><Routes><Route path="/admin" element={<Admin />} /><Route path="/posts" element={<PostsPage />} /><Route path="*" element={<Home />} /></Routes></BrowserRouter>;
}
